import incidentcallstats from "./incidentcallstats.reducer";
import { combineReducers } from "redux";

const reducer = combineReducers({
  incidentcallstats
});

export default reducer;
